/*
 * Banner copy: one quote per pass of the Horizon biplane.
 *
 * Up to three lines all in, attribution included -- a towed banner that needs
 * four is a banner nobody finishes reading before it leaves. Lines are cut by
 * hand rather than wrapped, so each break lands where the sense does.
 *
 * Deliberately not the culture creeds: those live in the YAML, and a second
 * copy here would drift the moment one was edited.
 */
export const QUOTES = [
  { text: ['Make it work, make it right,', 'make it fast.'], by: 'Kent Beck' },
  { text: ['Premature optimization', 'is the root of all evil.'], by: 'Donald Knuth' },
  { text: ['Programs must be written', 'for people to read.'], by: 'Abelson & Sussman' },
  { text: ['Talk is cheap.', 'Show me the code.'], by: 'Linus Torvalds' },
  { text: ['Plan to throw one away;', 'you will, anyhow.'], by: 'Fred Brooks' },
  { text: ['The best way to predict', 'the future is to invent it.'], by: 'Alan Kay' },
  { text: ['The most damaging phrase is:', 'we have always done it this way.'], by: 'Grace Hopper' },
  { text: ['Simplicity is prerequisite', 'for reliability.'], by: 'Edsger Dijkstra' },
  { text: ['When a measure becomes a target,', 'it ceases to be a good measure.'], by: 'Charles Goodhart' },
  { text: ['Organizations design systems', 'that mirror their own structure.'], by: 'Melvin Conway' },
  { text: ['You build it,', 'you run it.'], by: 'Werner Vogels' },
  { text: ['Anything that can go wrong,', 'will go wrong.'], by: "Edward A. Murphy Jr." },
];
